import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconButton, TextField, Shimmer, ShimmerElementType } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

const getStyle = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px 0',
  },
  pageNumber: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 5px',
  },
});

const textFieldStyles = {
  root: {
    width: 75,
    marginRight: 10,
  },
};

const Pagination = ({
  classes,
  pageSize,
  pageNumber,
  total,
  onPageChange,
}) => {
  const i18n = useContext(I18nContext);
  const totalPage = useMemo(() => ((total || total === 0) ? Math.ceil(total / pageSize) : undefined), [total, pageSize]);

  return (
    <div className={classNames(classes.container, 'pagination')}>
      <IconButton
        title={i18n.getString(_TL_('previous page'))}
        iconProps={{ iconName: 'ChevronLeft' }}
        disabled={pageNumber === 1 || totalPage === undefined}
        onClick={() => onPageChange(pageNumber - 1)}
      />
      <Shimmer
        className={classes.pageNumber}
        isDataLoaded={totalPage !== undefined}
        shimmerElements={[{ type: ShimmerElementType.line, height: 30, width: 60 }]}
      >
        <div className={classNames(classes.pageNumber, 'page-number')}>
          {totalPage !== undefined &&
            curlyTemplate(i18n.getString(_TL_('{{pageNumber}} of {{totalPage}}')))({
              pageNumber: totalPage === 0 ? 0 : pageNumber,
              totalPage: ` ${i18n.formatDecimal(totalPage)}`,
            })
          }
        </div>
      </Shimmer>
      <IconButton
        title={i18n.getString(_TL_('next page'))}
        iconProps={{ iconName: 'ChevronRight' }}
        disabled={pageNumber === totalPage || totalPage === undefined || totalPage === 0}
        onClick={() => onPageChange(pageNumber + 1)}
      />
    </div>
  );
};

Pagination.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    pageNumber: PropTypes.string.isRequired,
  }).isRequired,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number,
  onPageChange: PropTypes.func,
};

Pagination.defaultProps = {
  pageNumber: 1,
  total: null,
  onPageChange: () => {},
};

const Wrapped = withDefaultStyles(Pagination, getStyle);

export { Wrapped as Pagination };
